import { autoinject, bindable } from 'aurelia-framework';
import { PubSub } from 'lib/event/PubSub';
import { AsyncErrorHandler, DialogHandler } from 'lib/ui';
import { MooringProductionTaskType, PluckingListDto } from 'models/mooring';
import { ToastService } from 'services';
import { MooringProductionOrderService } from 'services/mooring';
import { HourListDialog } from '../hours/hour-list-dialog';

@autoinject
export class FleetAnchorLinesContainer {
  protected pluckList: PluckingListDto[] = [];

  @bindable
  productionOrderId: number;

  constructor(
    private productionOrderService: MooringProductionOrderService,
    private toast: ToastService,
    private pubsub: PubSub,
    private dialog: DialogHandler
  ) {}

  protected attached() {
    if (!this.productionOrderId || this.productionOrderId <= 0) {
      throw new Error('productionOrderId is required');
    }

    void this.getAnchorLinesPluckingList();
  }

  @AsyncErrorHandler
  async getAnchorLinesPluckingList() {
    const { data } = await this.productionOrderService.getFleetAnchorLinesPluckingList(this.productionOrderId);
    this.pluckList = data;
  }

  @AsyncErrorHandler
  protected async onSave({ canNavigateOnSave, entries }: { canNavigateOnSave: boolean; entries: PluckingListDto[] }) {
    if (!this.productionOrderId || this.productionOrderId <= 0) {
      throw new Error('productionOrderId is required');
    }

    const dto = entries.map((line) => ({
      ArticleId: line.ArticleId,
      Certificates: line.Certificates.map((certificate) => ({
        CertificateId: certificate.CertificateId,
        Quantity: certificate.Quantity,
        ActualBatchNo: certificate.ActualBatchNo,
      })),
    }));

    await this.productionOrderService.setFleetAnchorLinesPluckingList(this.productionOrderId, dto);
    this.toast.showUpdated();

    this.pubsub.publish('tabs:change-guard-ok', null);
    // if (canNavigateOnSave) {
    // }
    await this.getAnchorLinesPluckingList();
  }

  protected async openHoursDialog() {
    await this.dialog.open(HourListDialog, {
      productionOrderId: this.productionOrderId,
      taskOptions: [MooringProductionTaskType.FleetAnchorLinePicking, MooringProductionTaskType.FleetAnchorLineAssembly],
    });
  }
}
